export default __webpack_public_path__ + "assets/models/355b4cdf0fb1f2981dfe0a31301f7853.glb";